<template>
  <div class="view-container">
    <div class="icon-info">
      <img
        src="@/assets/info.svg"
        alt="info"
        height="30px"/>
    </div>
    <app-survey-init v-if="viewStatus === 'stat'"></app-survey-init>
    <app-survey-stat v-if="viewStatus === 'initial'"></app-survey-stat>
    <div @click="switchView" class="dev-only">
      <p>Switch</p>
    </div>
  </div>
</template>

<script>
import SurveyInit from '@/components/SurveyInit.vue';
import SurveyStat from '@/components/SurveyStat.vue';

export default {
  components: {
    'app-survey-init': SurveyInit,
    'app-survey-stat': SurveyStat,
  },
  data() {
    return {
      msg: 'Hi there!',
      viewStatus: 'stat',
      // -- init stat form
    };
  },
  methods: {
    switchView() {
      this.viewStatus = this.viewStatus === 'stat' ? 'initial' : 'stat';
    },
  },
};
</script>

<style scoped>
  .view-container {
    margin: 5%;
  }

  .icon-info {
    display: flex;
    justify-content: flex-end;
  }

  .dev-only {
    margin:20px;
  }
</style>
